// extracted by mini-css-extract-plugin
export default {"subcategoriesRow":"n_bz","subcategoryColumn":"n_bB","articleLink":"n_bC","articleCoverImage":"n_bD","articleTitle":"n_bF","articleMetaDescription":"n_bG"};